//Event bus code based on https://medium.com/@soffritti.pierfrancesco/create-a-simple-event-bus-in-javascript-8aa0370b3969
/**
 * subscriptions data format:
 * { eventType: { id: callback } }
 */
window.subscriptions = {};
window.getNextUniqueId = getIdGenerator();

window.subscribe = function (eventType, callback) {
    const id = getNextUniqueId();

    if (!subscriptions[eventType]) subscriptions[eventType] = {};

    subscriptions[eventType][id] = callback;

    return {
        unsubscribe: () => {
            delete subscriptions[eventType][id];
            if (Object.keys(subscriptions[eventType]).length === 0) delete subscriptions[eventType];
        },
    };
};

window.publish = function (eventType, arg) {
    if (!subscriptions[eventType]) return;

    Object.keys(subscriptions[eventType]).forEach((key) => subscriptions[eventType][key](arg));
};

function getIdGenerator() {
    let lastId = 0;

    return function getNextUniqueId() {
        lastId += 1;
        return lastId;
    };
}
